const AnchorBlockView = (props) => {
  const { data } = props;

  return <span id={data.name} className="anchor-link" />;
};

export default AnchorBlockView;
